import * as TogglePrimitive from '@radix-ui/react-toggle'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const toggleVariants = cva(
  'flex items-center h-12 w-full bg-neutral-25 border border-neutral-75 outline-none justify-center rounded font-light hover:bg-neutral-50 focus-visible:bg-neutral-50 outline-0 focus-visible:outline-2 focus:outline-2 outline-fig-300 outline-offset-1 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-neutral-75',
)

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>
>(({ className, ...props }, ref) => (
  <TogglePrimitive.Root ref={ref} className={toggleVariants({ className })} {...props} />
))

Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle, toggleVariants }
